<template>
    <div>
        <div id="pull-to-refresh">
            <div class="arrow">
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
            <div class="text"></div>
        </div>
        <div class="bg-info position-fixed top-0 w-100">
            <div class="container py-3">
                <div class="row">
                    <div class="col-12">
                        <h4 class="mb-0 text-white">{{ store_name }}</h4>
                    </div>
                </div>
            </div>
        </div>
        <div id="content">
            <slot></slot>
        </div>
        <div v-if="!hide_footer" class="bg-white position-fixed bottom-0 w-100">
            <div class="container py-3">
                <div class="d-flex justify-content-evenly gap-3">
                    <button class="btn btn-outline-info w-100" @click="goHome">
                        <i class="si si-home"></i>
                    </button>
                    <a class="btn btn-outline-info w-100" href="/liff/orders">
                        <i class="fa fa-shopping-basket"></i>
                    </a>
                    <a class="btn btn-outline-info w-100" href="/liff/edit-profile">
                        <i class="far fa-user"></i>
                    </a>
                </div>
            </div>
            <p class="mx-auto mb-0 text-center" style="font-size: 9px;">Powered by quinnus</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        hide_footer: {
            type: Boolean,
            default: false
        }
    },
    created() {
        // Set up global LIFF helper functions early
        this.setupGlobalLiffFunctions();
        
        // Handle multi-store scenario
        this.handleMultiStoreContext();
        
        window.addEventListener('localstorageSet', (e) => {
            this.store_name = e.detail.store_name
            // Update store_id from localStorage when it changes
            this.store_id = localStorage.getItem('store_id')
        });
    },
    mounted() {
        this.store_name = localStorage.getItem('store_name')
        this.store_id = localStorage.getItem('store_id')
        
        let startY = 0;
        let isPulling = false;
        const ptr = document.getElementById("pull-to-refresh");
        const threshold = 80;

        document.addEventListener("touchstart", (e) => {
            if (window.scrollY === 0) {
                startY = e.touches[0].clientY;
                isPulling = true;
            }
        });

        document.addEventListener("touchmove", (e) => {
            if (!isPulling) return;
            const distance = e.touches[0].clientY - startY;
            if (distance > 0) {
                ptr.style.transform = `translateY(${Math.min(distance, threshold)}px)`;
                e.preventDefault();
            }
        });

        document.addEventListener("touchend", (e) => {
            if (!isPulling) return;
            isPulling = false;
            const distance = e.changedTouches[0].clientY - startY;

            if (distance >= threshold) {
                ptr.classList.add("active");
                ptr.style.transform = `translateY(0px)`;
                setTimeout(() => {
                    location.reload(); // หรือ fetch ข้อมูลใหม่แทน
                }, 500);
            } else {
                ptr.style.transform = "translateY(-100%)";
            }
        });
    },
    data() {
        return {
            store_name: null,
            store_id: null
        }
    },
    methods: {
        handleMultiStoreContext() {
            // Clear store-specific data if switching between stores
            const currentStoreId = new URLSearchParams(window.location.search).get('store_id');
            const storedStoreId = localStorage.getItem('store_id');
            
            if (currentStoreId && storedStoreId && currentStoreId !== storedStoreId) {
                console.log(`Multi-store detected: switching from ${storedStoreId} to ${currentStoreId}`);
                this.clearStoreSpecificData();
            }
        },
        clearStoreSpecificData() {
            // Clear store-specific data while preserving user data
            localStorage.removeItem('store_id');
            localStorage.removeItem('liff_id');
            localStorage.removeItem('store_name');
            localStorage.removeItem('access_token');
            // Keep line_user_id - it's user-specific, not store-specific
            console.log('Store-specific data cleared for multi-store support');
        },
        setupGlobalLiffFunctions() {
            /**
             * LIFF Helper Functions - Available globally for all LIFF pages
             */
            window.goToLiffHome = () => {
                const storeId = this.getLiffStoreId();
                if (storeId) {
                    window.location.href = `/liff/profile?store_id=${storeId}`;
                } else {
                    console.warn('Store ID not found for home navigation');
                    window.location.href = '/liff/profile';
                }
            };

            window.getLiffStoreId = () => {
                // Priority order for multi-store support:
                // 1. URL parameters (current LIFF context) - highest priority
                // 2. Component's store_id data  
                // 3. localStorage (fallback only)
                return new URLSearchParams(window.location.search).get('store_id') ||
                       this.store_id || 
                       localStorage.getItem('store_id') ||
                       null;
            };

            window.goToLiffPage = (path) => {
                const storeId = window.getLiffStoreId();
                if (storeId && !path.includes('?') && !path.includes('store_id')) {
                    const separator = path.includes('?') ? '&' : '?';
                    window.location.href = `${path}${separator}store_id=${storeId}`;
                } else {
                    window.location.href = path;
                }
            };

            // Expose multi-store helper functions globally
            window.clearLiffStoreData = () => {
                this.clearStoreSpecificData();
            };

            window.handleLiffStoreSwitch = () => {
                this.handleMultiStoreContext();
            };
        },
        setupGlobalFunctions() {
            // Legacy method name - calls the new method
            this.setupGlobalLiffFunctions();
        },
        getLiffStoreId() {
            // Priority order for multi-store support:
            // 1. URL parameters (current LIFF context) - highest priority
            // 2. Component's store_id data
            // 3. localStorage (fallback only)
            return new URLSearchParams(window.location.search).get('store_id') ||
                   this.store_id || 
                   localStorage.getItem('store_id') ||
                   null;
        },
        goHome() {
            const storeId = this.getLiffStoreId();
            if (storeId) {
                window.location.href = `/liff/profile?store_id=${storeId}`;
            } else {
                console.warn('Store ID not found for home navigation');
                window.location.href = '/liff/profile';
            }
        }
    }
}
</script>

<style scoped>
#pull-to-refresh {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: #f1f1f1;
    text-align: center;
    line-height: 60px;
    transform: translateY(-100%);
    transition: transform 0.2s ease;
    z-index: 1000;
}

#pull-to-refresh.active {
    transform: translateY(0);
}

.arrow {
    font-size: 24px;
}

.text {
    font-size: 14px;
}

#content {
    margin-top: 57px;
    margin-bottom: 90px;
}
</style>
